import { RiwayatPendidikanResponse } from "../../../../models/RiwayatPendidikan";
import { getApiInstance } from "../../../api";
import mutationWrapper from "../../mutationWrapper";
import { allRiwayatPendidikanKey } from "../../queries/RiwayatPendidikan/useFetchAllRiwayatPendidikan";
import { checkProfileKey } from "../../queries/User/useFetchCheckProfile";
import getQueryClient from "../../queryClient";
import ApiClient from "../../../apiClient";

export async function removeRiwayatPendidikan(RIWAYAT_PENDIDIKAN_ID: number) {
  const res = await ApiClient.delete(
    `/RemovePendidikan?RIWAYAT_PENDIDIKAN_ID=${RIWAYAT_PENDIDIKAN_ID}`
  );
  return res.data[0];
}

export const useRemoveRiwayatPendidikan = mutationWrapper(
  removeRiwayatPendidikan,
  {
    onSuccess: () => {
      getQueryClient().invalidateQueries(allRiwayatPendidikanKey);
      getQueryClient().invalidateQueries(checkProfileKey);
    },
  }
);
